

import GAModel from "../models/ga4.model";
import * as gtag from "./gtag";
export default function UtilityService() {

    return {
        clickSendEvent(eventName: string, param_action: string) {

            let paramObject: GAModel  = {
                param_action_on : param_action
            }
            
            gtag.event(param_action ,paramObject)

        }
        , setPageTitle(title: string) {
            gtag.pageview(title);
        }
    }
}